import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteSettingsContext = createContext({ printify_store_url: null, refresh: () => {} });

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({ printify_store_url: null });

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/site/settings");
      setSettings(r.data || { printify_store_url: null });
    } catch {
      setSettings({ printify_store_url: null });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteSettingsContext.Provider value={{ ...settings, refresh }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
